
<div class="container-fluid header noprint tw-shadow-lg">
	<app-offline-detector></app-offline-detector>

	<div *ngIf="AuthenticationService.isAuthenticated()" class="d-flex justify-content-between text-center ">

		<div>

	</div>
			<div class="noprint d-flex justify-content-center   mt-2" style="max-width: 300px;">
					<a href="/landing"><img class="logo" src="assets/img/CL-horizontal-white.svg" /></a>
			</div>

			<div class="noprint d-flex align-items-center justify-content-end ml-2 mt-2 ">
					<div *ngIf="AuthenticationService.isAuthenticated()">
						<div class="d-flex align-items-center">
							<app-notification></app-notification>
							<div class="dropdown dropleft noprint">
								<i class="fa fa-bars fa-5x burger text-white" style="font-size: 30px;" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-hidden="true"></i>
								<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
									<a class="dropdown-item border-bottom" href="/landing"><i class="fa fa-home text-muted" aria-hidden="true"></i> Home</a>
									<button class="dropdown-item border-bottom" (click)="print()"><i class="fa fa-print text-muted" aria-hidden="true"></i> Print</button>
									<button class="dropdown-item" (click)="logout()"><i class="fa fa-sign-out text-muted" aria-hidden="true"></i> Sign out</button>
								</div>
							</div>
						</div>

			</div>
	</div>
</div>
<div class="noprint pointer-event back-button w-25" >
	<i *ngIf="url?.includes('/dashboard') && headerBackButton" style="font-size: 40px; cursor: pointer;" [routerLink]="[headerBackButton]" class="fa fa-arrow-circle-left align-middle mt-2 m-3" aria-hidden="true"></i>
</div>
